import { render } from "./labelUnset.vue?vue&type=template&id=cb8b9d3e&ts=true"
import script from "./labelUnset.vue?vue&type=script&lang=ts"
export * from "./labelUnset.vue?vue&type=script&lang=ts"

import exportComponent from "/home/asan/haisha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__